<template>
    <div class="row">
        <div class="col-12">
            <table class="table tabla-resumen mb-4 mb-lg-5">
                <tr class="lightgray-content">
                    <th></th>
                    <th>{{ $t('partido.entrada') }}</th>
                    <th class="price">{{ $t('partido.precio') }}</th>
                </tr>

                <tr>
                    <td>1</td>
                    <td>
                        <strong class="text-bold h5 d-block mb-1">{{ precio.description }}</strong>
                    </td>
                    <td>
                        <div class="h3 m-0">{{ precio.price_management_online_interno ? precio.price : parseFloat(precio.price) + parseFloat(precio.price_management_online) | formatear_precio }}</div>
                    </td>
                </tr>

                <tr>
                    <td></td>
                    <td></td>
                    <td><span class="total-price h3 m-0">{{ total | formatear_precio }}</span></td>
                </tr>
            </table>
        </div>

        <div class="col-12 col-lg-8 mt-4">
            <FormTerminos 
                :error="error"
                :desactivar="desactivar"
                @continuar="aceptarCondiciones"
            />
        </div>

        <b-col cols="12">
            <ResumenPrecioComponent :price="precio.price" :price_management="parseFloat(precio.price_management_online)" :price_management_interno="precio.price_management_online_interno"/>
        </b-col>

        <div class="col-12">
            <button class="button large-button effect-button" @click.prevent="terminar" :disabled="desactivar"><span>{{ $t('partido.continuar') }}</span></button>
            
            <template v-if="formulario_compra != null" >
                <div id="formulario-compra" v-html="formulario_compra" v-show="false"></div>
            </template>
        </div>
    </div>
</template>

<script>
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";

    export default {
        props: {
            precio: {
                type: Object,
                required: true
            },
            formulario_compra: {
                type: String,
                required: false
            },
            jet_id: {
                type: String,
                required: false
            },
            desactivar: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                terminos: false,
                error: null,
                loading: false
            }
        },
        methods: {
            terminar() {
                this.loading = true;
                if(this.terminos == true) {
                    if (!this.jet_id) {
                        setTimeout(() => {
                            document.getElementById('btn-pagar').click();
                        }, 500);
                    } else {
                        this.$emit('compraPaycomet');
                    }
                } else {
                    this.loading = false;
                    this.error = true;
                }
                
            },
            aceptarCondiciones(continuar) {
                this.terminos = continuar == true;
            }
        },
        computed: {
            total() {
                return this.precio.price_management_online_interno ? this.precio.price : parseFloat(this.precio.price) + parseFloat(this.precio.price_management_online)
            }
        },
        components: {
            ResumenPrecioComponent,
            FormTerminos
        }
    }
</script>